class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.stockNotice = document.querySelector('[data-stock-notice]');
    this.isQuickshop = true;
    if (this.dataset && this.dataset.isQuickshop) {
      this.isQuickshop = false;
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    //this.toggleAddButton(true, '', false);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      if (this.isQuickshop) {
        this.updateURL();
      }
      this.updateVariantInput();
      this.renderProductInfo();
      this.dispatchVariantChange();
    }
    this.updateStockNotice();
    this.updateProductData();
    this.updateProductSizing();
    this.updateProductProtection();
    this.updateLoyaltyPoints();
    this.updateEasysize();
  }

  updateProductData() {
    let selectedValue = document.querySelector('[data-option-input]:checked').value;
    let json = JSON.parse(document.querySelector('[data-variants-data]').dataset.variantsData);
    let result = json[selectedValue];
    let resultArr = result.split('|');
    if (document.querySelector('[data-product-sku]')) {
      document.querySelector('[data-product-sku]').innerText = resultArr[0];
    }
    if (document.querySelector('[data-product-ean]')) {
      document.querySelector('[data-product-ean]').innerText = resultArr[1];
    }
  }

  updateStockNotice() {
    if (this.stockNotice && this.stockNotice.dataset && this.stockNotice.dataset.stockNotice) {
      let variantData = JSON.parse(this.stockNotice.dataset.stockNotice);
      if (variantData) {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              if (!this.options[index]) {
                return true;
              }

              let newIndex = index;
              let option1_check = this.options[newIndex] === option;
              if (!option1_check) {
                if (newIndex == 0) {
                  newIndex = index + 1;
                } else {
                  newIndex = index - 1;
                }
              }
              return this.options[newIndex] === option;
            })
            .includes(false);
        });
        let selectedVariantData = variantData[this.currentVariant.id];
        if (selectedVariantData) {
          let array = selectedVariantData.split('|');
          this.stockNotice
            .querySelector('span')
            .classList.remove(
              'text-success',
              'text-theme-10',
              'text-theme-15',
              'text-theme-19',
              'text-new',
              'font-bold'
            );
          this.stockNotice.querySelector('span').innerHTML = array[0];
          let classes = array[1].split(' ');
          classes.forEach((className) => {
            this.stockNotice.querySelector('span').classList.add(className);
          });
        }
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          if (!this.options[index]) {
            return true;
          }
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent('variant-change', {
        bubbles: true,
        variant: this.currentVariant,
        detail: {
          variant: this.currentVariant,
        },
      })
    );
  }

  updateProductSizing() {
    let dataOptions = document.querySelectorAll('[data-option-input]');
    dataOptions.forEach((option) => {
      if (option.checked) {
        let the_option = option.closest('[data-option]');
        if (the_option) {
          let us_size = the_option.querySelector('.option__label-us').innerHTML;
          if (document.getElementById('US')) {
            document.getElementById('US').value = us_size;
          }
          let uk_size = the_option.querySelector('.option__label-uk').innerHTML;
          if (document.getElementById('UK')) {
            document.getElementById('UK').value = uk_size;
          }
          let eu_size = the_option.querySelector('.option__label-eu').innerHTML;
          if (document.getElementById('EUR')) {
            document.getElementById('EUR').value = eu_size;
          }
        }
      }
    });
  }

  updateProductProtection() {
    document.querySelectorAll('[data-protection-product-size]').forEach((protection) => {
      protection.innerHTML = this.currentVariant.option1;
      let dataArr = protection.closest('[data-product-protection]').dataset.productProtection;
      dataArr.split(',').forEach((data) => {
        let arr = data.split(':');
        if (arr[0] == this.currentVariant.option1) {
          protection
            .closest('[data-product-protection]')
            .querySelector('[data-protection-protection-size]').innerHTML = arr[1];
          if (
            protection
              .closest('[data-product-protection]')
              .querySelector('[data-variant-size="' + arr[1] + '"]')
          ) {
            protection
              .closest('[data-product-protection]')
              .querySelector('.bg-theme-18')
              .classList.remove('bg-theme-18', 'text-white');
            protection
              .closest('[data-product-protection]')
              .querySelector('[data-variant-size="' + arr[1] + '"]')
              .classList.add('bg-theme-18', 'text-white');
          }
        }
      });
    });
  }

  updateLoyaltyPoints() {
    const loyaltyPointsContainer = document.querySelector('[data-loyalty-points]');
    if (!loyaltyPointsContainer || !this.currentVariant) return;

    // Get variant data and settings from data attributes
    const currentCurrency = document.querySelector('[data-currency]')?.dataset.currency || 'EUR';
    const membershipPageUrl = document.querySelector('[data-membership-url]')?.dataset.membershipUrl;
    const membershipText = document.querySelector('[data-membership-text]')?.dataset.membershipText || 'Alpinestars Membership';

    // Get loyalty points from variants data (SKU | Barcode | LoyaltyPoints)
    let points = 0;
    const variantsData = JSON.parse(document.querySelector('[data-variants-data]').dataset.variantsData);
    const selectedValue = document.querySelector('[data-option-input]:checked').value;
    const variantDataString = variantsData[selectedValue];

    if (variantDataString) {
      const dataArray = variantDataString.split('|');
      const loyaltyPointsFromData = parseInt(dataArray[2]) || 0;


      if (loyaltyPointsFromData > 0) {
        points = loyaltyPointsFromData;
      } else {
        // For EUR currency, use the price as points
        if (currentCurrency === 'EUR') {
          points = Math.floor(this.currentVariant.price / 100);
        } else {
          points = loyaltyPointsFromData;
        }
      }
    }

    // If no points, hide the container
    if (!points || points <= 0) {
      loyaltyPointsContainer.parentElement.style.display = 'none';
      return;
    } else {
      loyaltyPointsContainer.parentElement.style.display = '';
    }

    // Build membership URL with checkout parameter
    let membershipUrl = membershipPageUrl || window.location.origin + '/pages/membership';

    // Update the content using translation from window object
    const earnPointsText = window.loyaltyPointsTranslation || `Earn <b class="font-bold">${points} points</b> with <a class="text-primary underline" href="${membershipUrl}">${membershipText}</a>`;
    loyaltyPointsContainer.innerHTML = earnPointsText.replace('{{ points }}', points).replace('{{ membership_url }}', membershipUrl);
  }

  // Update easysize script
  updateEasysize() {
    if (window.easy_size) {
      window.easy_size.refresh();
    }
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('hidden');
        if (this.currentVariant) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        }

        // Update the inventory quantity hidden input
        const productFormDestination = document.querySelector(`#product-form-${this.dataset.section}`);
        const productFormSource = html.querySelector(`#product-form-${this.dataset.section}`);
        const inventoryQtyDestination = productFormDestination?.querySelector('input[name="inventory_quantity"]');
        const inventoryQtySource = productFormSource?.querySelector('input[name="inventory_quantity"]');

        if (inventoryQtyDestination && inventoryQtySource) {
          inventoryQtyDestination.value = inventoryQtySource.value;
        }
      });
  }

  /**
   * toggleAddButton
   * @param {Boolean} disable
   * @param {String} text
   * @param {Boolean} modifyClass
   * @returns {void}
   */
  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('[data-add-to-cart-button-text]');
    const BiSButton = this.closest('product-info')?.querySelector('.klaviyo-bis-trigger');

    if (!addButton || !addButtonText) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
      addButton.classList.add('hidden');
      BiSButton && (BiSButton.style.display = 'block');
    } else {
      addButtonText.textContent = window.variantStrings.addToCart;
      addButton.removeAttribute('disabled');
      addButton.classList.remove('hidden');
      BiSButton && (BiSButton.style.display = 'none');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.updateOptions();
    this.updateMasterId();
    this.highlightOptions();
  }

  onVariantChange() {
    super.onVariantChange();
    this.highlightOptions();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  /*
   * Check for each option value if the other one/two selected variant options are available
   */
  highlightOptions() {
    // If no selected element make all available
    let selectedElement = event
      ? event.target
      : this.querySelector('[data-option-group] input[checked]');
    if (!selectedElement) {
      this.querySelectorAll('[data-option-group]').forEach((option) => {
        option.querySelectorAll('[data-option]').forEach((optionEl) => {
          let label = optionEl.querySelector('[data-option-label]');
          label.classList.remove('option-disabled');
        });
      });
      return;
    }

    // Loop over option groups
    this.querySelectorAll('[data-option-group]').forEach((option) => {
      // Get index from option group (1, 2 or 3)
      const optionIndex = parseInt(option.dataset.optionGroup);

      // Create compare options from group, remove selected option based on index
      const compareOptions = [...this.options].filter((option, index) => index != optionIndex);

      // Loop over possible values for option group
      option.querySelectorAll('[data-option]').forEach((optionEl) => {
        let label = optionEl.querySelector('[data-option-label]'),
          input = optionEl.querySelector('[data-option-input]'),
          value = input.value;

        // Match option availability and check if the two current options are available for value
        let match = this.getVariantData().filter((variant) => {
          // Get available variants where the current option index is the option value
          if (variant.options[optionIndex] == value && variant.available) {
            // Create variant options, remove option based on option value
            const variantOptions = [...variant.options].filter(
              (option, index) => index != optionIndex
            );

            // Check if compare options is the same as variant options
            return variantOptions.every(
              (item, index) => item.toLowerCase() === compareOptions[index].toLowerCase()
            );
          }

          return false;
        });

        // Enable disable variant options
        label.classList.toggle('option-disabled', match.length == 0);
      });
    });
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}
